import styled from '@emotion/styled';

export const PreWrapSpan = styled.span`
  white-space: pre-wrap;
`;
